import moment from 'moment';
export default function formatReftime(refTime, baseTime) {
  const refTimeMoment = moment(refTime);
  if (refTime === baseTime) {
    const result = refTimeMoment.utc();
    return [result.format('MMM DD, HH'), result.format('mm')]
  }

  const currentTime = refTimeMoment.utc();
  if (currentTime.hour() === 0) return [currentTime.format('MMM DD, HH'), currentTime.format('mm')];

  return [currentTime.format('HH'), currentTime.format('mm')];
}